import { motion } from 'framer-motion';
import { LegacyRef, useState } from 'react';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { GiCancel, GiConfirmed } from 'react-icons/gi';
import { useRescheduleHistoryContext } from '../../../contexts/RescheduleHistoryProvider';
import useUserClickObserver from '../../../hooks/useUserClickObserver';
import { RescheduleHistory } from '../../../types/history';
import ActionButton from '../../CommonComps/Buttons/ActionButton';

const RescheduleHistoryUpdateActions = ({
  rescheduleHistory,
}: {
  rescheduleHistory: RescheduleHistory;
}) => {
  // integration of react hooks here
  const [showMenu, setShowMenu] = useState<boolean>(false);

  // integration of context hooks here
  const { setShowConfirmModal, setShowRejectModal, setRescheduleHistory } =
    useRescheduleHistoryContext();

  // integration of custom hooks here
  const selectRef = useUserClickObserver(setShowMenu);

  // handler function to show modal on button click declared here
  const showModalHandler = (modalName: 'confirm' | 'reject') => {
    switch (modalName) {
      case 'confirm':
        setShowConfirmModal(true);
        break;

      case 'reject':
        setShowRejectModal(true);
        break;

      default:
        break;
    }

    setRescheduleHistory(rescheduleHistory);
  };

  // rendering reschedule history update actions component here
  return (
    <div ref={selectRef as LegacyRef<HTMLDivElement>} className='relative'>
      <div className='flex items-center justify-center'>
        <button
          onClick={() => setShowMenu((state) => !state)}
          className='hover:opacity-40 active:scale-90 duration-300'
        >
          <BsThreeDotsVertical className='size-6' />
        </button>
      </div>

      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={
          showMenu
            ? { height: 'fit-content', opacity: 1 }
            : { height: 0, opacity: 0 }
        }
        className='absolute bottom-1/2 right-0 bg-base-white shadow-academia-sm rounded-lg overflow-hidden '
      >
        <div className='max-h-[100px] overflow-y-auto'>
          <ActionButton
            onClick={() => showModalHandler('confirm')}
            colorClass='text-base-cyan'
          >
            <GiConfirmed />
            <span>Confirm Appointment</span>
          </ActionButton>

          <ActionButton
            onClick={() => showModalHandler('reject')}
            colorClass='text-base-red'
          >
            <GiCancel />
            <span>Reject Appointment</span>
          </ActionButton>
        </div>
      </motion.div>
    </div>
  );
};

export default RescheduleHistoryUpdateActions;
